import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from "react-i18next";
import * as en from "./locales/en.json";
import { DEFAULT_LANGUAGE } from "./constants/language";

i18n.on('languageChanged', () => {
  setTimeout(() => {
    window.document.title = i18n.t('general.title');
  }, 0);
});

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: {
        translation: (en as any).default
      }
    },
    fallbackLng: DEFAULT_LANGUAGE,
    debug: true,
    interpolation: {
      escapeValue: false
    }
  }).then();

window.document.title = i18n.t('general.title');

export default i18n;
